import { useConsent } from '../lib/consent';
import { useI18n } from '../i18n';
import { PrivacyBody, TermsBody } from './LegalContent';

export function LegalModal() {
  const { legalView, closeLegal } = useConsent();
  const { t } = useI18n();
  if (!legalView) return null;

  const title = legalView === 'privacy' ? t('legal.privacy_title') : t('legal.terms_title');

  return (
    <div class="legal-overlay" role="dialog" aria-modal="true" aria-labelledby="legalTitle">
      <div class="legal-backdrop" onClick={closeLegal} />
      <div class="legal-panel">
        <div class="legal-header">
          <h2 id="legalTitle">{title}</h2>
          <button class="legal-close" aria-label={t('legal.close')} onClick={closeLegal}>
            ×
          </button>
        </div>
        <div class="legal-body">
          {legalView === 'privacy' ? <PrivacyBody /> : <TermsBody />}
        </div>
        <div class="legal-footer">
          <button class="legal-cta" onClick={closeLegal}>
            {t('legal.close')}
          </button>
        </div>
      </div>
    </div>
  );
}
